var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promo-disabled"},[_c('info16',{staticClass:"promo-disabled__icon",attrs:{"width":16,"height":16}}),_c('p',{staticClass:"promo-disabled__text"},[_vm._v(" Акции на данный товар не распространяются ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }